export enum CompetitionFilterTypes {
  AgeGroup = "AgeGroup",
  League = "League",
}
